import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import { carouselData } from "../../data";
import { carouselDataArabic } from "../../data/indexArabic";
import { useAuth } from "../../store/auth";
import "./HeroSection.css";

const HeroSection = () => {
  const { isArabic, isDarkMode } = useAuth();
  const data = !isArabic ? carouselDataArabic : carouselData;
  const [isOpen, setIsOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const openModal = () => {
    setIsOpen(true);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % data.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + data.length) % data.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Auto slide functionality
  React.useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const currentData = data[currentSlide];

  return (
    <>
      <section className={`hero-section position-relative overflow-hidden ${isDarkMode ? 'hero-dark' : ''}`}>
        {/* Background with modern gradient */}
        <div className="hero-background">
          <div className="hero-gradient"></div>
          <div className="hero-shapes">
            <div className="hero-shape-1"></div>
            <div className="hero-shape-2"></div>
            <div className="hero-shape-3"></div>
            <div className="hero-shape-4"></div>
            <div className="hero-shape-5"></div>
          </div>
        </div>

        <Container className="position-relative" style={{ zIndex: 10 }}>
          <Row className="align-items-center min-vh-100 py-5">
            <Col lg={7} md={8} className="hero-content">
              <div className="hero-text-wrapper">
                <div className="hero-badge mb-4">
                  <span className="badge bg-soft-primary text-primary px-3 py-2 rounded-pill">
                    <FeatherIcon icon="star" className="fea icon-sm me-1" />
                    {currentData?.badgeText}
                  </span>
                </div>

                <h1 
                  className="hero-title display-4 fw-bold mb-4"
                  dangerouslySetInnerHTML={{ __html: currentData?.h1 }}
                />

                <p className="hero-description lead text-muted mb-5">
                  {currentData?.p}
                </p>

                <div className="hero-buttons d-flex flex-wrap gap-3 align-items-center">
                  <Link
                    to={currentData?.link}
                    className={`btn btn-lg ${currentData?.btnclass} rounded-pill px-4`}
                    onClick={currentData?.isVideo ? openModal : undefined}
                  >
                    {currentData?.isVideo ? (
                      <FeatherIcon icon="play" className="fea icon-sm me-2" />
                    ) : (
                      <i className={`${currentData?.iClass} me-2`}></i>
                    )}
                    {currentData?.btntext}
                  </Link>

                  {currentData?.isVideo && (
                    <span className="hero-watch-text fw-medium text-muted">
                      {currentData?.buttontext}
                    </span>
                  )}
                </div>
              </div>
            </Col>

            <Col lg={5} md={4} className="d-none d-md-block">
              <div className="hero-visual position-relative">
                <div className="hero-icon-grid">
                  <div className="hero-icon-item">
                    <FeatherIcon icon="wind" className="text-primary" size={40} />
                  </div>
                  <div className="hero-icon-item">
                    <FeatherIcon icon="thermometer" className="text-primary" size={40} />
                  </div>
                  <div className="hero-icon-item">
                    <FeatherIcon icon="settings" className="text-primary" size={40} />
                  </div>
                  <div className="hero-icon-item">
                    <FeatherIcon icon="shield" className="text-primary" size={40} />
                  </div>
                  <div className="hero-icon-item">
                    <FeatherIcon icon="tool" className="text-primary" size={40} />
                  </div>
                  <div className="hero-icon-item">
                    <FeatherIcon icon="home" className="text-primary" size={40} />
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* Navigation controls */}
          {/* {data.length > 1 && (
            <div className="hero-navigation">
              <div className="hero-nav-dots d-flex justify-content-center gap-2 mb-4">
                {data.map((_, index) => (
                  <button
                    key={index}
                    className={`hero-dot ${index === currentSlide ? 'active' : ''}`}
                    onClick={() => goToSlide(index)}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>

              <div className="hero-nav-arrows">
                <button 
                  className="hero-arrow hero-arrow-prev"
                  onClick={prevSlide}
                  aria-label="Previous slide"
                >
                  <FeatherIcon icon="chevron-left" size={20} />
                </button>
                <button 
                  className="hero-arrow hero-arrow-next"
                  onClick={nextSlide}
                  aria-label="Next slide"
                >
                  <FeatherIcon icon="chevron-right" size={20} />
                </button>
              </div>
            </div>
          )} */}
        </Container>
      </section>
    </>
  );
};

export default HeroSection;
